import {apiClient} from 'core/apiClient';
import {OrganizationRawRow} from 'types/profile';

const URL = '/service/legal-identities';

export async function fetchOrganizationList() {
    return (await apiClient.get<OrganizationRawRow[]>(URL)).data;
}
